<script setup lang="ts">
import { AppButton, BlockFooter, type ButtonColor, useDialog } from 'duanaga-ui'

const props = withDefaults(
  defineProps<{
    cancelText?: string
    helperText?: string
    hideCancel?: boolean
    submitColor?: string
    submitText?: string
    submitting?: boolean
  }>(),
  {
    cancelText: 'Cancel',
    helperText: '',
    hideCancel: false,
    submitColor: 'black',
    submitText: 'Save',
    submitting: false
  }
)

const { hideDialog } = useDialog()
</script>

<template>
  <BlockFooter>
    <div class="flex flex-col gap-12 text-left md:flex-row md:items-center md:justify-end">
      <p
        v-if="props.helperText"
        class="text-14 text-grey-70"
      >
        {{ props.helperText }}
      </p>
      <div class="flex w-full justify-end gap-12 md:w-auto">
        <AppButton
          v-if="!props.hideCancel"
          type="button"
          :disabled="props.submitting"
          :text="props.cancelText"
          @click="hideDialog"
        />
        <AppButton
          type="submit"
          :color="props.submitColor as ButtonColor"
          :loading="props.submitting"
          :text="props.submitText"
        />
      </div>
    </div>
  </BlockFooter>
</template>
